import { render, staticRenderFns } from "./movePanelDialog.vue?vue&type=template&id=17fe20e9&"
import script from "./movePanelDialog.vue?vue&type=script&lang=js&"
export * from "./movePanelDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports